import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { AccountResponse } from '../../../types/Account';

export type AccountFilterKey = 'uuid' | 'account_type' | 'account_status';

export type AccountFilterParam = {
  [K in AccountFilterKey]?: (string | null)[];
};

export type AccountSortParam = {
  [K in AccountAvailableColumns]?: -1 | 1;
};

export type AccountAvailableColumns =
  | 'name'
  | 'code'
  | 'phone'
  | 'manager_display_name'
  | 'manager_email'
  | 'school_district_value'
  | 'status_value'
  | 'type_value'
  | 'tags';

export type UseGetAllAccountsParams = {
  page?: number;
  per_page?: number;
  search?: string;
  filters?: AccountFilterParam;
  sort?: AccountSortParam;
  list_columns?: AccountAvailableColumns[];
};

export type UseGetAllAccountsProps = {
  params?: UseGetAllAccountsParams;
  enabled?: boolean;
};

export const fetchAllAccounts = async ({ params }: UseGetAllAccountsProps) => {
  const response = await CustomAxios.get<AccountResponse>(`accounts`, { params });
  const { data } = response;
  return data;
};

export function useGetAllAccounts({ params, enabled = true }: UseGetAllAccountsProps) {
  const queryKey: any = [queryKeys.allAccounts, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllAccounts({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
